import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} clientsByStore
 * @returns {Workbook}
 */
export const exportExcel = async (
  clientsByStore,
  selectedStore,
  startDate,
  endDate
) => {
  const json = excelHelper.jsonToJson(
    [clientsByStore],
    [
      {
        name: "NUEVOS CLIENTES POR SEDE",
        props: [
          {
            inValue: "storeName",
            outValue: "SEDE",
          },
          {
            inValue: "new",
            outValue: "CANTIDAD NUEVOS CLIENTES",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        "reporte-nuevos-clientes-general_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        "reporte-nuevos-clientes_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardNewClients/excel.js